import { AppConstants } from "../../../app.constants";

export class WindowPreviewInfo {
  Handle: { value: number } = { value: AppConstants.FULL_SCREEN_DEFAULT_HANDLE };
  Image: string;
  Title: string = AppConstants.FULL_SCREEN_TITLE;

  constructor(values: any = {}) {
    Object.assign(this, values);
  }
}
